/** The width of the "explain" label in the top right of an annotation input */
export const EXPLANATION_LABEL_WIDTH = "44px";
/** The width of the annotation input label, considering the explanation label width */
export const ANNOTATION_INPUT_LABEL_WIDTH = `calc(100% - ${EXPLANATION_LABEL_WIDTH})`;
